import React from 'react';

const EmailValidateIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M20 7.238L12.072 14.338L4 7.216V19H13V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V11H20V7.238ZM19.501 5H4.511L12.061 11.662L19.502 5H19.501ZM22 17H23V22H15V17H16V16C16 15.2044 16.3161 14.4413 16.8787 13.8787C17.4413 13.3161 18.2044 13 19 13C19.7956 13 20.5587 13.3161 21.1213 13.8787C21.6839 14.4413 22 15.2044 22 16V17ZM20 17V16C20 15.7348 19.8946 15.4804 19.7071 15.2929C19.5196 15.1054 19.2652 15 19 15C18.7348 15 18.4804 15.1054 18.2929 15.2929C18.1054 15.4804 18 15.7348 18 16V17H20Z"
      fill="currentColor"
    />
  </svg>
);

export default EmailValidateIcon;
